<template>
	<div id="kt_content_container" class="container d-flex flex-column">
		<div class="page d-flex flex-row flex-column-fluid w-100">
			<div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
				<div class="content flex-row-fluid mt-5" id="kt_content">
					<div class="row mb-5">
						<div
							class="col-xl-3 col-md-4 sectionContainer"
							v-if="isListVisible"
							:class="{ listClass: isListVisible }"
						>
							<ChatList
								:conversations="conversations"
								:locale="locale"
								:isSizePhoneMode="isSizePhoneMode"
								@select-conversation="updateSelectedConversation"
                                :tenant="tenant"
							></ChatList>
						</div>
						<div
							v-if="isChatVisible"
							class="col col-xl-6 col-md-8 sectionContainer sliding"
							:class="{
								'col-xl-9':
									!selectedConversationId || (selectedConversationId && chatExpanded),
								chatClass: isChatVisible,
							}"
						>
							<Chat
                                ref="chat"
								:locale="locale"
								:tenant="tenant"
								:profile="profile"
								:marketplace="marketplace"
								:conversationId="selectedConversationId"
								:hasNewMsg="hasNewMsg"
								:isSizePhoneMode="isSizePhoneMode"
								@back="backToChatList"
								@show-profile="showProfile"
								@toggleProfile="toggleProfile"
								@showTemplate="showTemplate"
							></Chat>
						</div>
						<div class="col col-xl-3 col-md-8 sectionContainer sliding" v-if="showTemplatePreview || showEditProfile || isProfileVisible">
							<template v-if="showTemplatePreview">
								<TemplatePreview :data="templateData" @hideTemplate="hideTemplate"/>
							</template>
                            <template v-else-if="showEditProfile">
                                <EditProfile :data="profileData" @hideEditProfile="hidEditProfileSection"/>
                            </template>
							<template
								v-else-if="isProfileVisible"
								:class="{ profileClass: isSizePhoneMode }"
							>
								<Profile
									:conversation="selectedConversationId"
									:hasNewMsg="hasNewMsg"
									:locale="locale"
                                    :tenant="tenant"
									v-if="isProfileVisible"
									:isSizePhoneMode="isSizePhoneMode"
									:isSizeTableMode="isSizeTableMode"
									@back="backToChat"
                                    @show-edit="showEditProfileSection"
                                    @sendInvoice="sendInvoice"
								/>
							</template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<OrderDetails />
</template>

<script>
import ChatList from '@/components/whatsapp-managment/includes/ChatList.vue';
import Profile from '@/components/whatsapp-managment/includes/Profile';
import Chat from '@/components/whatsapp-managment/includes/Chat.vue';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '@/firebase';
import { useToast } from 'vue-toastification';
import OrderDetails from '@/components/whatsapp-managment/includes/Profile/OrderDetails/index.vue';
import TemplatePreview from './includes/TemplatePreview';
// import { FFmpeg } from '@ffmpeg/ffmpeg';
import EditProfile from './includes/Profile/edit';

export default {
	name: 'WhatsappComponent',
	components: {
		ChatList,
		Chat,
		Profile,
		OrderDetails,
		TemplatePreview,
        EditProfile,

	},
	props: {
		locale: null,
		marketplace: null,
		profile: '',
		tenant: 299,
	},
    // provide() {
    //     return {
    //         ffmpeg: this.ffmpeg
    //     }
    // },
	data() {
		return {
			filters: [],
			selectedConversationId: null,
			pageSettings: {},
			conversations: [],
			hasNewMsg: false,
			isSizePhoneMode: false,
			currentPage: 'list', //list,chat,profile
			chatClass: '',
			listClass: '',
			profileClass: '',
			minSize: 768,
			minTableSize: 1199,
			isSizeTableMode: false,
			authenticationTries: 0,
			chatExpanded: localStorage.getItem('chatExpanded') == 'true',
			showTemplatePreview: false,
            showEditProfile: false,
			templateData: {},
            // ffmpeg: new FFmpeg({ log: true }),
            profileData: {},
		};
	},
    beforeMount() {
        // this.ffmpeg.load();
    },
    async mounted() {
		this.setLocale();
		this.setPageSettings();
      // TODO: remove
		// await this.$store.dispatch('Chat/authenticateWithFirebase');
		this.loadConversations();

		// Check for iPhone size on mount
		this.isSizePhoneMode = window.innerWidth <= this.minSize;

		this.isSizeTableMode = window.innerWidth <= this.minTableSize;

		// Listen for window resize events
		window.addEventListener('resize', this.handleWindowResize);

		this.$emit('component-loaded');
	},
	beforeDestroy() {
		// Remove the window resize event listener on component destroy
		window.removeEventListener('resize', this.handleWindowResize);
	},
	computed: {
		base_url() {
			return window.location.origin;
		},
		toasts() {
			return this.$store.getters['Toasts/toasts'];
		},
		isListVisible() {
			return !this.isSizePhoneMode || (this.isSizePhoneMode && this.currentPage === 'list');
		},
		isChatVisible() {
			return (
				(!this.isSizePhoneMode && !this.isSizeTableMode) ||
				(this.isSizePhoneMode && this.currentPage === 'chat') ||
				(this.isSizeTableMode &&
					(this.currentPage === 'chat' || this.currentPage === 'list')) ||
				this.chatClass !== ''
			);
		},
		isProfileVisible() {
			return (
				this.selectedConversationId &&
				(this.profileClass !== '' ||
					((this.isSizePhoneMode || this.isSizeTableMode) && this.currentPage === 'profile') ||
					(!this.isSizePhoneMode && !this.isSizeTableMode && !this.chatExpanded))
			);
		},
	},
	watch: {
		conversations() {
			if (this.selectedConversationId) {
				const item = this.conversations.find(
					(item) => this.selectedConversationId.whatsapp_id == item.whatsapp_id,
				);
				this.selectedConversationId.last_message = item?.last_message;
				this.hasNewMsg = item?.last_message?.is_new;
			} else {
				this.hasNewMsg = false;
			}
		},
		toasts(newValue) {
			const { type, message } = newValue[newValue.length - 1];
			useToast()[type](message);
		},
	},
	methods: {
		applyAnimate() {},
		setLocale() {
			this.$i18n.locale = this.locale;
			localStorage.setItem('lang', this.locale === 'en' ? 'en' : 'ar');
		},
		setPageSettings() {},
		updateCurrentPage(page) {
			this.currentPage = page;
		},
		backToChatList() {
			this.selectedConversationId = null;
			//animate
			this.listClass = 'slide-left-in';
			this.updateCurrentPage('list');
			setTimeout(() => {
				this.listClass = '';
			}, 500);
		},
		backToChat() {
			//animate
			this.chatClass = 'slide-left-in';
			this.updateCurrentPage('chat');
			setTimeout(() => {
				this.chatClass = '';
			}, 500);
		},
		showProfile() {
			//animate
			this.profileClass = 'slide-right-in';
			this.updateCurrentPage('profile');
			setTimeout(() => {
				this.profileClass = '';
			}, 500);
		},
		updateSelectedConversation(conversationId) {
		    this.hidEditProfileSection();
			this.selectedConversationId = conversationId;
			//animate
			this.chatClass = 'slide-right-in';
			this.updateCurrentPage('chat');
			setTimeout(() => {
				this.chatClass = '';
			}, 500);
		},
		async loadConversations() {
			try {
				const conversationsCollection = collection(db, `tenants/${this.tenant}/conversations`);
				onSnapshot(
					query(conversationsCollection, orderBy('timestamp', 'desc')), // <-- Added orderBy("timestamp") here
					(querySnapshot) => {
						this.conversations = querySnapshot.docs.map((doc) => ({
							...doc.data(),
							id: doc.id,
							tenantId: this.tenant,
						}));
					},
				);
			} catch (error) {
				console.error('Failed to fetch data:', error);
			}
		},
		handleWindowResize() {
			// Update the isSizePhoneMode computed property on window resize
			this.isSizePhoneMode = window.innerWidth <= this.minSize;
			this.isSizeTableMode = window.innerWidth <= this.minTableSize;
		},
		toggleProfile(newVal) {
			this.chatExpanded = newVal;
		},
		showTemplate(value) {
			this.showTemplatePreview = true;
			this.templateData = value;
		},
		hideTemplate() {
			this.showTemplatePreview = false;
			this.templateData = {};
		},
		showEditProfileSection(value) {
			this.showEditProfile = true;
			this.profileData = value;
		},
		hidEditProfileSection() {
			this.showEditProfile = false;
            this.profileData = {};
		},
        sendInvoice(data) {
            console.log({data});
            this.$refs['chat'].updateUploadedDocument(data);
            this.$refs['chat'].sendMessage();
        }
	},
};
</script>
<style scoped lang="scss">
.sectionContainer {
	height: 800px;
}

.sliding {
	transition: width 0.75s;
}

/* Slide left animation */
@keyframes slideLeftIn {
	from {
		transform: translateX(100%);
	}

	to {
		transform: translateX(0);
	}
}

/* Slide right animation */
@keyframes slideRightIn {
	from {
		transform: translateX(-100%);
	}

	to {
		transform: translateX(0);
	}
}

/* Apply animation to an element with the class 'slide-left' */
.slide-left-in {
	animation: slideLeftIn 0.5s ease-in;
}

/* Apply animation to an element with the class 'slide-right' */
.slide-right-in {
	animation: slideRightIn 0.5s ease-in;
}

.custom-container {
	padding: 0px 2rem !important;
	width: 100%;
}

.page {
	flex: 1;
}

.wrapper {
	flex: 1;
}

.content {
	flex: 1;
	overflow-y: auto;
}
</style>
